export default __webpack_public_path__ + "static/media/inspiracion.6476bd36.jpg";